"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (Object.hasOwnProperty.call(mod, k)) result[k] = mod[k];
    result["default"] = mod;
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importStar(require("react"));
var mobx_react_1 = require("mobx-react");
var ApiService_1 = require("../services/ApiService");
require("./AllCardsView.css");
var Paper_1 = __importDefault(require("@material-ui/core/es/Paper/Paper"));
var Spinner_1 = __importDefault(require("./Spinner"));
var Typography_1 = __importDefault(require("@material-ui/core/es/Typography/Typography"));
var CharacterSelection_1 = __importDefault(require("./CharacterSelection"));
var IconButton_1 = __importDefault(require("@material-ui/core/es/IconButton/IconButton"));
var Card_1 = require("../models/Card");
var icons_1 = require("@material-ui/icons");
var AllCardsView = /** @class */ (function (_super) {
    __extends(AllCardsView, _super);
    function AllCardsView() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    AllCardsView.prototype.componentDidMount = function () {
        this.props.characterDataStore.loadCharacterData();
    };
    AllCardsView.prototype.render = function () {
        var store = this.props.characterDataStore;
        return (react_1.default.createElement(react_1.default.Fragment, null,
            react_1.default.createElement(Paper_1.default, { style: { margin: "1rem", padding: "1rem" } },
                react_1.default.createElement(Typography_1.default, { variant: "body1" },
                    "Level ",
                    store.level,
                    react_1.default.createElement("input", { type: "range", value: store.level, min: 1, max: 9, step: 1, onChange: store.changeLevel, style: { width: "15rem", height: "1rem" } })),
                react_1.default.createElement(CharacterSelection_1.default, null)),
            react_1.default.createElement(Paper_1.default, null, !store.finished ? react_1.default.createElement(Spinner_1.default, null) :
                store.availableCards.map(function (card) {
                    var cardInScenarioDeck = card.inScenarioDeck ? "card-in-scenario-deck" : "";
                    var cardInPlayerDeck = card.inPlayerDeck ? "card-in-player-deck" : "";
                    var cardImageClasses = "card-image " + cardInPlayerDeck + " " + cardInScenarioDeck;
                    return (react_1.default.createElement("div", { key: card.name, className: "card" },
                        react_1.default.createElement("img", { src: card.imgUrl, alt: card.name, onClick: function () { return store.toggleToFromScenarioDeck(card); }, onError: function () {
                                card.imgUrl = ApiService_1.ApiService.defaultCardUrl(store.selectedCharacter);
                            }, className: cardImageClasses }),
                        react_1.default.createElement(IconButton_1.default, { onClick: function () { return store.toggleToFromPlayerDeck(card); }, className: "card-to-from-player-deck", "aria-label": "Toggle to-from player deck", style: { display: Card_1.Card.alwaysInPlayerDeck(card) ? "none" : "initial" } },
                            react_1.default.createElement(icons_1.LibraryAdd, { style: { display: card.inPlayerDeck ? "none" : "initial" } }),
                            react_1.default.createElement(icons_1.DeleteForever, { style: { display: !card.inPlayerDeck ? "none" : "initial" } }))));
                }))));
    };
    AllCardsView = __decorate([
        mobx_react_1.inject("characterDataStore"),
        mobx_react_1.observer
    ], AllCardsView);
    return AllCardsView;
}(react_1.Component));
exports.default = AllCardsView;



//////////////////
// WEBPACK FOOTER
// ./src/components/AllCardsView.tsx
// module id = 779
// module chunks = 0